import { render, staticRenderFns } from "./Eliminar.vue?vue&type=template&id=41c09c19"
import script from "./Eliminar.vue?vue&type=script&lang=js"
export * from "./Eliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports